<script lang="ts">
  // @ts-ignore
  // @ts-nocheck

  import { AceEditor } from 'svelte-ace'
  import 'brace/mode/java'
  import 'brace/theme/solarized_light'

  import 'unplugin-icons/types/svelte'
  import MdiCog from '~icons/mdi/cog'
  import MdiChevronDoubleRight from '~icons/mdi/chevron-double-right'
  import MdiChevronDoubleUp from '~icons/mdi/chevron-double-up'

  import { Button, Card, Dialog, Loading, Modal } from 'attractions'

  import { sleep } from './lib/utils.js'
  import { compile } from './lib/compiler.js'

  import { preamble, postamble, source } from './lib/strings.js'

  let code: string = source

  let compileButtonClass: string = 'visibleButton'
  let loadButtonClass: string = 'hiddenButton'
  let nextButtonClass: string = 'hiddenButton'

  let modalOpen: boolean = false
  let modalTitle: string = 'Compilation Results'
  let modalWait = false
  let modalContent: string = ''

  const resetHandler = () => {
    compileButtonClass = 'visibleButton'
    loadButtonClass = 'hiddenButton'
    nextButtonClass = 'hiddenButton'
    code = ''
  }

  const compileHandler = async () => {
    modalTitle = 'Compiling...'
    modalContent = 'Please wait...'
    modalWait = true
    modalOpen = true

    await sleep(2000)

    let ast
    try {
      ast = await compile(code)
    } catch (e) {
      modalTitle = 'Compilation Error'
      modalContent = `Error: ${e.message}`
      modalWait = false
      return
    }

    modalTitle = 'Compilation Results: Success'
    modalContent = 'Your code has been successfully compiled.'
    modalWait = false
    modalOpen = true

    loadButtonClass = 'visibleButton'
  }

  const loadHandler = async () => {
    modalTitle = 'Loading your code into the robot...'
    modalContent = 'Please wait...'
    modalWait = true
    modalOpen = true

    await sleep(3000)

    modalTitle = 'Robot Loaded'
    modalContent = 'Your code has been successfully loaded into the robot.'
    modalWait = false
    compileButtonClass = 'hiddenButton'
    loadButtonClass = 'hiddenButton'
    nextButtonClass = 'visibleButton'
  }

  const nextHandler = async () => {
    nextButtonClass = 'hiddenButton'
  }
</script>

<Card outline>
  <div style="background-color:antiquewhite;padding:1em;border-radius:1.25em">
    <pre>{preamble}</pre>
    <AceEditor width="90%" height="500px" lang="java" theme="solarized_light" bind:value={code} />
    <pre>{postamble}</pre>
  </div>
  <Card outline>
    <div style="text-align: center">
      {#if nextButtonClass === 'visibleButton'}
        <Button style="display:inline-block" filled on:click={nextHandler}>
          <MdiChevronDoubleRight />&nbsp;Next
        </Button>
      {:else}
        <Button style="display:inline-block" selected on:click={compileHandler}>
          <MdiCog />&nbsp;Compile
        </Button>

        {#if loadButtonClass === 'visibleButton'}
          <Button style="display:inline-block" filled on:click={loadHandler}>
            <MdiChevronDoubleUp />&nbsp;Load Into Robot
          </Button>
        {/if}

        <Button style="display:inline-block" danger outline on:click={resetHandler}>Reset</Button>
      {/if}
    </div>
  </Card>
</Card>

<Modal bind:open={modalOpen} let:closeCallback>
  <Dialog title={modalTitle} {closeCallback}>
    <pre>{modalContent}</pre>
    {#if modalWait}
      <div style="display:flex;justify-content:center;">
        <Loading />
      </div>
    {/if}
  </Dialog>
</Modal>
